import React, { useEffect, useState } from 'react';
import EnhancedTable from 'src/components/enhanced-table/EnhancedTable';
import {
  EnhanceTableHeaderTypes,
  EnhancedTableColumnType,
  ITableMenuAction
} from 'src/components/enhanced-table';
import { useAppDispatch } from 'src/redux/hooks';
import { IConfirmation } from 'src/redux/confirmation/types';
import { OpenConfirmation } from 'src/redux/confirmation/confirmationReducer';
import { Helmet } from 'react-helmet-async';
import MainPageTitle from 'src/components/layout-components/main-layout/MainPageTitle';
import { useNavigate } from 'react-router';
import { DataService } from 'src/services/data-service';
import Loader from 'src/components/Loader';
import { ensurePlusPrefix } from 'src/helpers/utils';
import { toast } from 'react-toastify';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import AddUser from './add-user';
import { IUserDetails } from '.';

interface IUserListing {
  id: string;
  username: string;
  role: string;
  status: string;
}

const UserListing: React.FC = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<Record<string, Record<string, any>>>();
  const [openAddUser, setOpenAddUser] = useState<boolean>(false);

  const headers: EnhanceTableHeaderTypes[] = [
    { id: 'username', label: 'Username', type: EnhancedTableColumnType.TEXT },
    { id: 'role', label: 'Role', type: EnhancedTableColumnType.TEXT },
    {
      id: 'status',
      label: 'Status',
      type: EnhancedTableColumnType.COLORED_CHIP,
      chipColors: {
        Active: { backgroundColor: 'green', color: 'white' },
        Inactive: { backgroundColor: 'red', color: 'white' }
      }
    }
    // {
    //     id: 'actions', label: 'Actions', type: EnhancedTableColumnType.Action,
    //     actions: [
    //         { onClick: (id) => { activate(id) }, icon: <CheckIcon fontSize="small" />, label: "Activate User", hidden: (r) => r.status?.toLowerCase() === "active" },
    //         { onClick: (id) => { deactivate(id) }, icon: <CancelIcon fontSize="small" />, label: "Deactivate User", hidden: (r) => r.status?.toLowerCase() === "inactive" || r.status?.toLowerCase() === "pending" },
    //     ]
    // }
  ];

  // const activate = (id: string) => {
  //     const confimation: IConfirmation = {
  //         open: true,
  //         title: "Confirmation",
  //         message: "Do you want to activate this user?",
  //         onSubmit: async () => {
  //             const result = await DataService.post("api/user/activate/" + id, {});
  //             if (result.ok) {
  //                 initilize();
  //                 toast.success("Success!");
  //             } else {
  //                 toast.error("An error occured");
  //             }
  //         }
  //     };

  //     dispatch(OpenConfirmation(confimation));
  // }

  // const deactivate = (id: string) => {
  //     const confimation: IConfirmation = {
  //         open: true,
  //         title: "Confirmation",
  //         message: "Do you want to deactivate this user?",
  //         onSubmit: async () => {
  //             const result = await DataService.post("/api/user/deactivate/" + id, {});
  //             if (result.ok) {
  //                 initilize();
  //                 toast.success("Success!");
  //             } else {
  //                 toast.error("An error occured");
  //             }
  //         }
  //     };

  //     dispatch(OpenConfirmation(confimation));
  // }

  const initilize = async () => {
    setLoading(true);
    const response = await DataService.get('api/user/all');
    if (response.ok) {
      const list: IUserDetails[] = await response.json();

      // Transform response into a Record with a unique key (use index as fallback)
      const result: Record<string, IUserListing> = {};
      list.forEach((c, index) => {
        result[c.username || `user_${index}`] = {
          id: c.username || `user_${index}`,
          username: c.username,
          role: c.role,
          status: c.active ? 'Active' : 'Inactive'
        };
      });

      setData(result); // Set the data as a Record
      setLoading(false);
    } else {
      toast.error('Failed to fetch users.');
      setLoading(false);
    }
  };

  useEffect(() => {
    initilize();
  }, []);

  const actions: ITableMenuAction[] = [
    {
      key: 'adduser',
      title: 'Add User',
      disabled: (selected: string[]) => selected.length > 0,
      onClick: () => {
        setOpenAddUser(true);
      }
    }
  ];

  if (!data || loading) {
    return <Loader size={75} />;
  }

  return (
    <div>
      <Helmet>
        <title>User Listing</title>
      </Helmet>
      <title>User's List</title>
      <MainPageTitle
        title={'Users List'}
        action={{
          title: 'Add User',
          onClick: () => {
            if (!openAddUser) {
              setOpenAddUser(true);
            }
          }
        }}
      />

      {}

      <EnhancedTable
        title="Users"
        header={headers}
        data={data}
        actions={actions}
      />

      {openAddUser && (
        <AddUser
          onSuccess={function (): void {
            setOpenAddUser(false);
            initilize();
          }}
          onClose={function (): void {
            setOpenAddUser(false);
          }}
        />
      )}
    </div>
  );
};

export default UserListing;
